var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#80ff80",
    height: "64px",
    width: "64px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.605 492.605",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.708,373.559h-7.106v-46.982c0-20.182-16.421-36.594-36.595-36.594H262.728v-58.328h70.399 c41.673,0,75.442-33.787,75.442-75.455c0-41.67-33.77-75.43-75.442-75.43c-0.593,0-1.186,0.064-1.779,0.096 C322.671,34.836,282.308,0,233.754,0c-54.839,0-99.339,44.465-99.339,99.359c0,8.373,1.137,16.461,3.096,24.225 c-1.059-0.072-2.037-0.322-3.096-0.322c-29.94,0-54.182,24.264-54.182,54.209c0,28.703,21.711,52.297,49.934,54.184h99.725v58.328 H81.593c-20.188,0-36.589,16.412-36.589,36.594v46.982h-7.106c-19.885,0-36,16.117-36,36v47.047c0,19.885,16.115,36,36,36h47.048 c19.887,0,36.001-16.115,36.001-36v-47.047c0-19.883-16.114-36-36.001-36H77.84v-46.982c0-2.07,1.687-3.754,3.753-3.754h148.299 v50.736h-7.104c-19.888,0-36.001,16.117-36.001,36v47.047c0,19.885,16.113,36,36.001,36h47.046c19.887,0,36.001-16.115,36.001-36 v-47.047c0-19.883-16.114-36-36.001-36h-7.105v-50.736h148.279c2.072,0,3.754,1.684,3.754,3.754v46.982h-7.101 c-19.886,0-36.001,16.117-36.001,36v47.047c0,19.885,16.115,36,36.001,36h47.048c19.881,0,36-16.115,36-36v-47.047 C490.708,389.676,474.589,373.559,454.708,373.559z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.3c51d1fb50a00ee026539d86d0688072.svg";
export { ForwardRef as ReactComponent };